import { render, staticRenderFns } from "./mypercentage.vue?vue&type=template&id=1cf456cf&scoped=true"
import script from "./mypercentage.vue?vue&type=script&lang=js"
export * from "./mypercentage.vue?vue&type=script&lang=js"
import style0 from "./mypercentage.vue?vue&type=style&index=0&id=1cf456cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf456cf",
  null
  
)

export default component.exports